<script lang="ts" setup>
import { useRouter } from "vue-router";
import logo from "@/assets/img/logo.svg";
import { ref } from "vue";

const isMobileMenuOpen = ref(false);
const route = useRouter();

const toggleMobileMenu = () => {
  isMobileMenuOpen.value = !isMobileMenuOpen.value;
};
const closeMobileMenu = () => {
  isMobileMenuOpen.value = false;
};
</script>

<template>
  <header :class="{ isMobileMenuOpen }">
    <div class="logo_area">
      <router-link to="/">
        <img :src="logo" alt="Logo" height="40" />
      </router-link>
    </div>
    <button
      class="hamburger_menu"
      @click="toggleMobileMenu"
      :class="{ 'is-active': isMobileMenuOpen }"
    >
      <span class="bar"></span>
      <span class="bar"></span>
      <span class="bar"></span>
    </button>
    <nav class="site_nav" :class="{ 'is-open': isMobileMenuOpen }">
      <ul>
        <li :class="{ active: route.currentRoute.value.path === '/' }">
          <router-link to="/" @click="closeMobileMenu"
            >トップページ</router-link
          >
        </li>
        <li
          :class="{ active: route.currentRoute.value.path === '/philosophy' }"
        >
          <router-link to="/philosophy" @click="closeMobileMenu"
            >私たちの思い</router-link
          >
        </li>
        <li :class="{ active: route.currentRoute.value.path === '/feature' }">
          <router-link to="/feature" @click="closeMobileMenu"
            >私たちの強み</router-link
          >
        </li>
        <li :class="{ active: route.currentRoute.value.path === '/result' }">
          <router-link to="/result" @click="closeMobileMenu"
            >お客様の声</router-link
          >
        </li>
        <li :class="{ active: route.currentRoute.value.path === '/contact' }">
          <router-link to="/contact" @click="closeMobileMenu"
            >お問い合わせ</router-link
          >
        </li>
      </ul>
    </nav>
  </header>
</template>

<style scoped>
header {
  position: fixed;
  width: 100%;
  display: grid;
  grid-template-columns: 1fr auto 1fr;
  align-items: center;
  justify-content: flex-start;
  padding: 24px 56px;
  z-index: 1000;
  background: linear-gradient(
    to right,
    rgba(255, 220, 182, 0.95),
    rgba(255, 226, 182, 0.95)
  );
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
}
.logo_area {
  margin-right: 16px;
  grid-column: 1 / 2;
}
.logo_area img {
  max-width: 184px;
  height: auto;
}
.hamburger_menu {
  display: none;
  background: none;
  border: none;
  cursor: pointer;
  padding: 0;
  width: 30px;
  height: 24px;
  position: relative;
  z-index: 1001;
  grid-column: 3 / 4;
  justify-self: end;
}
.hamburger_menu .bar {
  display: block;
  width: 100%;
  height: 3px;
  background-color: #8b4812;
  border-radius: 2px;
  position: absolute;
  left: 0;
  transition: all 0.3s ease;
}
.hamburger_menu .bar:nth-child(1) {
  top: 0;
}
.hamburger_menu .bar:nth-child(2) {
  top: 10px;
}
.hamburger_menu .bar:nth-child(3) {
  top: 20px;
}
.hamburger_menu.is-active .bar:nth-child(1) {
  transform: translateY(10px) rotate(45deg);
}
.hamburger_menu.is-active .bar:nth-child(2) {
  opacity: 0;
}
.hamburger_menu.is-active .bar:nth-child(3) {
  transform: translateY(-10px) rotate(-45deg);
}
.site_nav {
  grid-column: 2 / 3;
  justify-self: center;
}
.site_nav ul {
  display: flex;
  gap: 24px;
  list-style: none;
  padding: 0;
  margin: 0;
}
.site_nav li a {
  display: block;
  text-align: center;
  border: 2px solid #8b4812;
  border-radius: 16px;
  background-color: white;
  padding: 8px 24px;
  transition: border-color 0.15s ease, background-color 0.15s ease;
  cursor: pointer;
  white-space: nowrap;
  color: #45230b;
  text-decoration: none;
}
.site_nav li a:hover {
  background-color: #8b4812;
  border-color: #ffffff;
  color: white;
}
.site_nav li.active a {
  background-color: #8b4812;
  color: white;
}

@media (max-width: 1130px) {
  header {
    padding: 32px 32px;
  }
  .logo_area {
    margin-right: 16px;
  }
  .site_nav ul {
    gap: 8px;
  }
}

@media (max-width: 1000px) {
  header {
    grid-template-columns: auto 1fr auto;
    padding: 8px 16px;
    background: linear-gradient(
      to right,
      rgba(255, 220, 182, 1),
      rgba(255, 226, 182, 1)
    );
    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
    transition: background 0.3s ease;
  }
  .logo_area {
    grid-column: 1 / 2;
  }
  .hamburger_menu {
    display: block;
  }
  .site_nav {
    grid-row: unset;
    position: fixed;
    top: 0;
    right: 0;
    width: 100%;
    height: 100%;
    background: linear-gradient(
      to right,
      rgba(255, 220, 182, 0.95),
      rgba(255, 226, 182, 0.95)
    );
    transform: translateX(100%);
    transition: transform 0.3s ease-out;
    z-index: 1;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }
  .site_nav.is-open {
    transform: translateX(0);
  }
  .site_nav ul {
    flex-direction: column;
    gap: 12px;
    width: 100%;
    max-width: 80%;
    align-items: center;
  }
  .site_nav li {
    width: 100%;
  }
  .site_nav li a {
    padding: 8px 24px;
    font-size: 1.1rem;
  }
}
@media (max-width: 800px) {
  header {
    padding: 8px 16px;
    position: sticky;
    top: 0;
  }
  header.blurred {
    background: linear-gradient(
      to right,
      rgba(255, 220, 182, 1),
      rgba(255, 226, 182, 1)
    );
  }
  .site_nav {
    background: linear-gradient(
      to right,
      rgba(255, 220, 182, 1),
      rgba(255, 226, 182, 1)
    );
  }
}
</style>
